export default __webpack_public_path__ + "static/media/discovery.b7e1acce.svg";